import React, {useEffect, useState} from 'react'
import {Link} from 'react-router-dom'

import {usersService} from 'services'
import requestHandler from 'utils/requestHandler'
import useUserContext from 'components/User/useUserContext'

const UserProfile = () => {
  const {user} = useUserContext()

  const [initData, setInitData] = useState(undefined)

  useEffect(() => {
    setInitData({loading: true})
    /*
    requestHandler(() => usersService.getBillingInfo(user.uuid), 'json')
      .then(r => {
        if (r.success) {
          console.log({...r.data})
          setInitData(r.data)
        } else {
          setInitData(null)
        }
      })
     */
  }, [user.uuid])

  return (
    <div>
      <Link to='/profile/billing-info'>Billing info</Link>
    </div>
  )
}

export default UserProfile
